module.exports = __webpack_public_path__ + "static/family-74466658183e411d956369d0888cdecf.png";